import { Navigation } from "../components/landing/Navigation";
import { Hero } from "../components/landing/Hero";
import { Positioning } from "../components/landing/Positioning";
import { Problem } from "../components/landing/Problem";
import { Services } from "../components/landing/Services";
import { Proof } from "../components/landing/Proof";
import { FounderNote } from "../components/landing/FounderNote";
import { Process } from "../components/landing/Process";
import { CallToAction } from "../components/landing/CallToAction";
import { Footer } from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#F7F7F5]">
      <Navigation />
      <Hero />
      <Positioning />
      <Problem />
      <Services />
      <Proof />
      <FounderNote />
      <Process />
      <CallToAction />
      <Footer />
    </div>
  );
}
